import React, { useEffect, useState } from 'react'
import "./style.scss"
import { toAbsoluteUrl } from '../../../utils/assetHelper';
import {isVideoFile, getMp4Url} from '../../../utils/videoHelper';
import { wrapBoxWithColorClass } from '../../../utils/htmlConversion';
import 'react-quill/dist/quill.snow.css';

const Index = ({setOpenMethodologyModal, selectedProduct, modalName, setModalName}) => {
  const [methodologyData, setMethodologyData] = useState(null)

useEffect(() => {
 if(selectedProduct && modalName){
  if(selectedProduct?.metadata?.images?.find((item) => modalName === 'Multiplexed Protein Expression Testing' ? item?.name === 'Multiplexed Protein Expression and Host Cell Protein' : modalName === 'Wide Field' ? item.name === 'Widefield' : modalName === 'Super Resolution / Single Molecule - STORM' ? item.name === 'Super Resolution - Single Molecule STORM' : modalName === 'Super Resolution PALM' ? item.name === 'Super Resolution - PALM' : modalName === 'Super Resolution SIM' ? item.name === 'Super Resolution - SIM' : modalName === 'Super Resolution SIM²' ? item.name === 'Super Resolution - SIM²' : modalName === 'Super Resolution Airyscan' ? item.name === 'Super Resolution - Airyscan' : item.name === modalName)){
    setMethodologyData(selectedProduct?.metadata?.images?.find((item) => modalName === 'Multiplexed Protein Expression Testing' ? item?.name === 'Multiplexed Protein Expression and Host Cell Protein' : modalName === 'Wide Field' ? item.name === 'Widefield' : modalName === 'Super Resolution / Single Molecule - STORM' ? item.name === 'Super Resolution - Single Molecule STORM' : modalName === 'Super Resolution PALM' ? item.name === 'Super Resolution - PALM' : modalName === 'Super Resolution SIM' ? item.name === 'Super Resolution - SIM' : modalName === 'Super Resolution SIM²' ? item.name === 'Super Resolution - SIM²' : modalName === 'Super Resolution Airyscan' ? item.name === 'Super Resolution - Airyscan' : item.name === modalName))
  }
 }

},[modalName])

const openPrintDialog = (pdfUrl) => {
  window.open(pdfUrl, '_blank');
}


  return (
    <div className="small-modal-wrapper">
      <div className={`small-modal-content team-modal-content`}>
        <span className='close' onClick={() => {
          setOpenMethodologyModal(false)
          setModalName("")
        }} ><i className="fal fa-times"></i></span>
        <div className="img-container">
          {isVideoFile(methodologyData) ? <video src={getMp4Url(methodologyData?.url)} autoPlay loop muted controls style={{objectFit:'cover'}}></video> : 
          <img src={methodologyData?.url || toAbsoluteUrl("/media/methodologyplaceholder.png")} alt="" />
          }
        </div>
        <div className="team-text">
          <h3>{methodologyData?.name ? methodologyData?.name : "No Methodology Available"}</h3>
          <div style={{overflowY: 'auto', height:`${methodologyData?.methods ? 'auto' : '380px'}`}} className='ql-snow'>
         {methodologyData?.methods ? <p className='method ql-editor' style={{height: ((methodologyData?.name !== 'Multiplexed Protein Expression and Host Cell Protein') && (methodologyData?.name !== 'Multiplexed Protein Expression Testing') && (methodologyData?.name !== 'Super Resolution - Single Molecule STORM')) &&  '380px', textAlign:'inherit'}} dangerouslySetInnerHTML={{__html: methodologyData?.methods ? wrapBoxWithColorClass(methodologyData?.methods) : "No Methodology Available"}}></p>
          : <p style={{padding:'12px 10px', background:'#FFF2E5', borderRadius:'12px', color:'#DC4405', fontWeight:700}}>Data Collection In Progress</p>
        }
        </div>
        <div className='methodologybtn-container'>
        {(methodologyData?.pdf && methodologyData?.methods) &&
          <button className='btn' onClick={() => {
            openPrintDialog(methodologyData?.pdf)
          }}>Download PDF</button>
        }
          <button className='btn transparent' onClick={() => {
            setOpenMethodologyModal(false)
            setModalName("")
          }}>Close</button>
        </div>
        </div>
      </div>
    </div>
  )
}

export default Index